import { createSelector } from '@reduxjs/toolkit';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';

export const selectCurrentPage = (state: ReduxApplicationState) =>
  state.products.lastPageLoaded || 0;

export const selectPreviousPage = (state: ReduxApplicationState) =>
  state.products.lastPageLoaded ? state.products.lastPageLoaded - 1 : 0;

export const selectTotalProducts = (state: ReduxApplicationState) => state.products.totalProducts;

export const selectProductFromCode = createSelector(
  [
    ({ products }: ReduxApplicationState) => products.pages,
    (_, productCode: number) => productCode,
  ],
  (products, productCode) =>
    Object.values(products)
      .flat()
      .find(({ code }) => code === productCode),
);

export const selectProviderAttributionToken = ({ products }: ReduxApplicationState) =>
  products.providerAttributionToken;

export const selectProviderMetadata = ({ products }: ReduxApplicationState) =>
  products.providerMetadata;
